
'use client';

import { consultants } from "./consultant-data"; // Corrected import
import { Job } from "./mock-data";

export type User = {
  id: string;
  name: string;
  avatarUrl: string;
  dataAiHint?: string;
  isBot?: boolean;
  mainExpertise?: string;
  experience?: string;
  successfulCandidates?: number;
  strengths?: string[];
  messengerId?: string;
  zalo?: string;
  avatar?: string; // Add avatar for compatibility
  phone?: string
};

export type Attachment = {
  type: 'image' | 'video' | 'file';
  url: string;
  fileName?: string;
}

export type Message = {
  id: string;
  sender: User | any;
  text: string;
  timestamp: string;
  isLoading?: boolean;
  recommendations?: any;
  suggestedReplies?: string[];
  attachment?: Attachment;
  job?: Job; // Add job property
};

export type Conversation = {
  id: string;
  participants: any[];
  messages: Message[];
};

// Define different user personas for testing
export const loggedInUser: User = {
  id: 'user-0',
  name: 'Lê Ngọc Hân',
  avatarUrl: 'https://placehold.co/100x100.png?text=Me',
};

export const guestUser: User = {
  id: 'user-guest-123', // A different ID for the guest
  name: 'Khách',
  avatarUrl: 'https://placehold.co/100x100.png?text=G',
};

// AI Bot persona
export const helloJobBot: User = {
  id: 'bot-hellojob',
  name: 'HelloJob AI',
  avatarUrl: '/img/favi2.png',
  dataAiHint: 'friendly robot mascot',
  isBot: true,
};


// Initial conversations data
export const conversations: Conversation[] = [
  {
    id: 'convo-bot-hellojob',
    participants: [guestUser, helloJobBot], // Will be updated dynamically by context
    messages: [
      // This will be dynamically generated by ChatContext
    ],
  },
];